/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIBulkUnsubscription } from '../../models/api/bulk-unsubscription.model'

const resource = {
    main: 'services',
    module: 'bulk-unsubscriptions'
}

export class BulkUnsubscriptionServices {
    public static getBulkUnsubscriptions () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getBulkUnsubscriptionsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getBulkUnsubscriptionsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static getBulkUnsubscriptionsFileById (id: number) {
        return service.get(`${resource.main}/${resource.module}/download/${id}`, {
            responseType: 'arraybuffer'
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static createBulkUnsubscriptionPending (params: any) {
        const form = new FormData()
        form.append('uploadfile', params.uploadfile)
        return service.post(`${resource.main}/${resource.module}/unsubscription-pending`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static createBulkUnsubscriptions (params: APIBulkUnsubscription) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editBulkUnsubscriptions (id: number, params: APIBulkUnsubscription) {
        return service.put(`${resource.main}/${resource.module}/${id}`, params)
    }

    // public static deleteBulkUnsubscriptions (id: number) {
    //     return service.delete(`${resource.main}/${resource.module}/${id}`)
    // }
}
